import { useMemo } from "react";

import {
    applyFurnaceVentsToScope,
    applyRoofPitchToScope,
    sanitizeVariableName,
} from "../../../utils/formulaScope";
import { ROOF_MEASUREMENT_KEYS } from "../../../constants/roofMeasurements";
import { useEstimateContractContextManager } from "./";

const DEFAULT_NUMERIC_SCOPE: Record<string, number> = {
    Area: 0,
    Eave: 0,
    Rake: 0,
    Ridge: 0,
    Hip: 0,
    Valley: 0,
    RollValley: 0,
    HeadWallMetalQty: 0,
    StepFlashingQty: 0,
    CounterFlashingQty: 0,
    BoxVentQty: 0,
    TurbineVentQty: 0,
    RoofVents: 0,
    PlumbingJacksQty: 0,
    SplitBootsQty: 0,
    FurnaceVents: 0,
    BathVentQty: 0,
    DryerVentQty: 0,
    GutterLengthQty: 0,
    DownspoutLengthQty: 0,
    ScreenLength: 0,
    KickoutDiverterQty: 0,
};

const DEFAULT_STRING_SCOPE: Record<string, string> = {
    ValleyType: "",
    EaveDripEdge: "",
    RakeDripEdge: "",
    BathVentSize: "",
    DryerVentSize: "",
    CounterFlashingSize: "",
    GutterSize: "",
    DownspoutSize: "",
    RoofColor: "",
    UnderlaymentType: "",
    VentilationType: "",
};

export function useCalculationScope() {
    const { values, initLoading } = useEstimateContractContextManager();

    const scope = useMemo(
        () => buildScope(values.measurements, values.attributes),
        [values.measurements, values.attributes],
    );

    return {
        scope,
        loading: initLoading,
    };
}

function buildScope(measurements: any, attributes: any) {
    let scope: any = {
        ...DEFAULT_NUMERIC_SCOPE,
        ...DEFAULT_STRING_SCOPE,
    };

    for (const key of ROOF_MEASUREMENT_KEYS) {
        const entry = measurements[key];
        scope[sanitizeVariableName(key)] = Number(
            entry?.Actual ?? entry?.Calculated ?? 0,
        );
    }

    for (const [key, value] of Object.entries(attributes || {})) {
        if (key === "RoofPitch") {
            const roofPitch = applyRoofPitchToScope(value);
            scope = { ...scope, ...roofPitch };
            continue;
        }

        if (key === "FurnaceVents") {
            scope = { ...scope, ...applyFurnaceVentsToScope(value) };
            continue;
        }

        scope[sanitizeVariableName(key)] = value;
    }

    return scope;
}
